<template>
  <div class="new-main centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>在线考试</span>
    </div>
    <div class="d-flex">
      <div class='view-wrap'>
        <!--      <div class='title'>{{ dataInfo.name }}</div>-->
        <!--      <div class='title1'>(满分{{ dataInfo.score }}分，考试时间{{ dataInfo.time }}分钟)</div>-->
        <div v-for='(item, index) in dataList' :key='index' class='list-ti'>
          <div v-if='item.question_type == 1' class="biaoti">
            <span class='tit1'>一. 单选题</span>
            <span class='tit2'>(每道题只有一个正确答案，共 {{
                item.questions.length || 0
              }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
          </div>
          <div v-if='item.question_type == 2' class="biaoti">
            <span class='tit1'>二. 多选题</span>
            <span class='tit2'>(每道题答案数目不固定，共 {{
                item.questions.length || 0
              }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
          </div>
          <div v-if='item.question_type == 3' class="biaoti">
            <span class='tit1'>三. 判断题</span>
            <span class='tit2'>(选择正确或错误，共 {{
                item.questions.length || 0
              }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
          </div>
          <div class='mt10'>
            <div v-for='(item1, index1) in item.questions' class='mt10 mb10' :key="index1">
              <div class="timu_tit">
                <span>{{ index1 + 1 }}</span>
                <span>{{ item1.title }}</span>
              </div>
              <div class='ml50' v-if='item1.type == 1'>
                <el-radio-group v-model="item1.checked" @change="toSwitch(item1)">
                  <div v-for="(item2, index2) in item1.option" class='ml20 mt10' :key="index2"
                       @mouseenter="handleMouseEnter(item1,item2,index2)" @mouseleave="handleMouseLeave(item2,index2)">
                    <el-radio :label="item2.label">
                         <span
                             :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                             item2.label
                           }}. {{ item2.content }}</span>
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
              <div class='ml50' v-if='item1.type == 2'>
                <el-checkbox-group v-model="item1.checkList" @change="toSwitch(item1)">
                  <div v-for="(item2, index2) in item1.option" class='ml20 mt10' :key="index2"
                       @mouseenter="handleMouseEnter(item1,item2,index2)" @mouseleave="handleMouseLeave(item2,index2)">
                    <el-checkbox :label="item2.label">
                      <span
                          :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                          item2.label
                        }}. {{ item2.content }}</span>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div class='ml50' v-if='item1.type == 3'>
                <el-radio-group v-model="item1.checked" @change="toSwitch(item1)">
                  <div v-for="(item2, index2) in item1.option" class='ml20 mt10' :key="index2"
                       @mouseenter="handleMouseEnter(item1,item2,index2)" @mouseleave="handleMouseLeave(item2,index2)">
                    <el-radio :label="item2.label">
                         <span
                             :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                             item2.label
                           }}. {{ item2.content }}</span>
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-right">
        <div class="top-wrap d-flex">
          <div class="left-tit">
            <img src="../assets/images/dati.png" alt="">
            <span>答题卡</span>
          </div>
          <div class="right-tit">
            <img src="../assets/images/time.png" alt="">
            <span>{{ formattedRemaining }}</span>
          </div>
        </div>
        <div class="number-wrap">
          <div class="number-item" :class="item.yida?'classA':''" v-for="(item,index) in allQuestions" :key="index">
            {{ Number(index + 1) }}
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-jiao">
      <div class="right-tit">
        <img src="../assets/images/time.png" alt="">
        <span>{{ formattedRemaining }}</span>
      </div>
      <div class="btn" @click="toJJ">
        交卷
      </div>
    </div>
  </div>
</template>

<script>
import {
  sjdetail,
  submit_ks
} from "@/api/index";

export default {
  name: "examList",
  data() {
    return {
      dataInfo: {},
      dataList: [],
      allQuestions: [],
      time: '',
      id: '',
      zhunyeId: '',
      true_color: '',
      error_color: '',
      startTime:'',
      endTime:''
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.zhunyeId = this.$route.query.zhunyeId
    let start = (JSON.parse(localStorage.getItem('exam')).startTime)*1000
    console.log(start)
    this.startTime = this.getFormattedDateTime(start)
    this.getDetails()
    // 页面加载时若已有考试，则继续倒计时
    if (this.$store.state.currentExam && !this.$store.state.countdownInterval) {
      this.$store.commit('START_COUNTDOWN')
    }
  },
  computed: {
    currentExamName() {
      return this.$store.state.currentExam?.name || '无考试进行中'
    },
    formattedRemaining() {
      return this.$store.getters.formattedRemaining
    }
  },
  watch: {
    formattedRemaining(newValue) {
      if (newValue === '00:00:00') {
        this.submitExam();
      }
    },
  },
  methods: {
    getFormattedDateTime(timestamp) {
      let now = ''
      if (timestamp) {
        now = new Date(timestamp);
      }else {
        now = new Date();
      }

      const year = now.getFullYear(); // 获取年份
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 获取月份，注意要加1，并且确保是两位数
      const day = String(now.getDate()).padStart(2, '0'); // 获取日，确保是两位数

      const hours = String(now.getHours()).padStart(2, '0'); // 获取小时，确保是两位数
      const minutes = String(now.getMinutes()).padStart(2, '0'); // 获取分钟，确保是两位数
      const seconds = String(now.getSeconds()).padStart(2, '0'); // 获取秒，确保是两位数

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getDetails() {
      sjdetail({id: this.id}).then(res => {
        if (res.code == 1) {
          if (res.data.info.is_tip == 1) {
            this.true_color = res.data.info.true_color
            this.error_color = res.data.info.error_color
          }else {
            this.true_color = ''
            this.error_color = ''
          }

          let data = res.data.list
          let allQuestions = [];
          for (let i in data) {
            for (let j in data[i].questions) {
              if (data[i].questions[j].type == 3) {
                data[i].questions[j].option = [
                  {
                    label: '1',
                    defaultColor: "#333",
                    hoverColor: null,
                    content: '正确',
                  },
                  {
                    label: '2',
                    defaultColor: "#333",
                    hoverColor: null,
                    content: '错误',
                  }
                ]
              } else {
                if (typeof data[i].questions[j].option == 'string') {
                  data[i].questions[j].checked = ''
                  data[i].questions[j].checkList = []
                  let option = data[i].questions[j].option.split('\n')
                  const options = option.map((item, index) => {
                    return {
                      label: String.fromCharCode(65 + index),
                      defaultColor: "#333",
                      hoverColor: null,
                      content: item,
                    };
                  });
                  data[i].questions[j].option = options
                }
              }
              allQuestions.push({...data[i].questions[j], yida: false})
            }
          }
          this.dataList = data
          this.allQuestions = allQuestions
          console.log(this.dataList)
        }
      })
    },
    toStart() {

    },
    handleMouseEnter(question, option, optIndex) {
      if (question.answer.includes(option.label) || question.answer == option.content) {
        option.hoverColor = this.true_color
      } else {
        option.hoverColor = this.error_color
      }
    },
    handleMouseLeave(option) {
      option.hoverColor = null;
    },
    currentChange() {

    },
    submitExam() {
      this.toJJ()
    },
    toSwitch(item) {
      console.log(item)
      for (let i in this.allQuestions) {
        if (this.allQuestions[i].id == item.id) {
          this.allQuestions[i].yida = true
        }
      }
      this.$forceUpdate()
    },
    toJJ() {
      let a = []
      this.dataList.forEach((item)=>{
        for (let i in item.questions) {
          if (item.questions[i].type == 1) {
            a.push({
              question_id:item.questions[i].id,
              answer:item.questions[i].checked,
            })
          }else if (item.questions[i].type == 2){
            a.push({
              question_id:item.questions[i].id,
              answer:item.questions[i].checkList.length?item.questions[i].checkList.join(','):'',
            })
          }else if (item.questions[i].type == 3){
            a.push({
              question_id:item.questions[i].id,
              answer:item.questions[i].checked == 1?'正确':item.questions[i].checked == 2?'错误':'',
            })
          }
        }
      })
      let ajax = {
        major_id: this.zhunyeId,
        shijuan_id: this.id,
        start_time:this.startTime,
        end_time:this.getFormattedDateTime(),
        list:a,
      }
      submit_ks(ajax).then(res => {
        if (res.code == 1) {
          this.$message.success('交卷成功！')
          localStorage.removeItem('exam')
          this.$store.dispatch('stopCountdown')
          this.$router.push({
            path: '/examList',
            query: {}
          })
        }else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.view-wrap {
  flex: 1;
  margin-top: 30px;
  margin-bottom: 50px;
  //max-height: 500px;
  //overflow: auto;
  &::-webkit-scrollbar {
    width: 0;
  }

  .title {
    font-size: 24px;
    color: #333;
    text-align: center;
  }

  .title1 {
    text-align: center;
    font-size: 14px;
    color: #999;
  }

  .list-ti {
    margin-top: 20px;

    &:first-child {
      margin-top: 0;
    }

    .biaoti {
      background: #2257ab14;
      padding: 15px 20px;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }

    .tit1 {
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }

    .tit2 {
      font-size: 14px;
      color: #999;
      margin-left: 20px;
    }
  }
}

.view-right {
  width: 280px;
  margin-left: 20px;

  .left-tit {
    width: 140px;
    background: #33acc9;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      color: #ffffff;
      margin-left: 5px;
    }
  }

  .right-tit {
    width: 140px;
    height: 50px;
    background: #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      color: red;
      margin-left: 5px;
    }
  }
}

.bottom-jiao {
  display: flex;
  justify-content: space-between;
  background: #f6f6f6;
  width: 900px;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;

  .right-tit {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      color: red;
      margin-left: 5px;
      font-size: 18px;
    }
  }

  .btn {
    background: #409EFF;
    color: #ffffff;
    padding: 10px 36px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
  }
}

.mt10 {
  margin-top: 15px;
  font-size: 16px;
}

.timu_tit {
  color: #000000;
  font-weight: bold;
  display: flex;
  align-items: center;

  span:nth-child(1) {
    background: #409EFF;
    width: 26px;
    height: 26px;
    display: inline-block;
    border-radius: 50%;
    line-height: 26px;
    text-align: center;
    color: #fff;
    margin-right: 16px;
  }
}

.ml50 {
  margin-left: 50px;
}

.number-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  .number-item {
    border-radius: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #eee;
    margin-right: 10px;
    margin-bottom: 10px;

    &:nth-child(6n) {
      margin-right: 0;
    }
  }

  .classA {
    background: #409EFF !important;
    border: 1px solid transparent;
    color: #ffffff !important;
  }
}
</style>
